/** Hard limits enforced by the schemas (PLAN.md §6, decision 5). */
export const MAX_HORIZON_YEARS = 60;
export const MAX_HORIZON_MONTHS = MAX_HORIZON_YEARS * 12;

export const MIN_MC_PATHS = 100;
export const MAX_MC_PATHS = 10_000;
export const MC_PATH_PRESETS = [1_000, 5_000, 10_000] as const;
